import React, { useState } from "react";
import { useSelector } from "react-redux";

import { ErrorBox } from "../../../components/error-box/error-box.component";
import { InfiniteScrollModal } from "../../../components/modals/infinite-scroll-modal/infinite-scroll-modal.component";
import { ListingTable } from "../../../components/layout/listing-table/listing-table.component";
import { SpinnerLoader } from "../../../components/loaders";
import { withShowIf } from "../../../components/with-show-if/with-show-If.component";

import * as store from "../store/product-history.store";

import { ProductHistoryProps } from "./product-history.props";
import { HistoryButton } from "./history-button/history-button.component";
import { defaultColumnConfiguration } from "./product-history.configuration";

export const ProductHistory = withShowIf((props: ProductHistoryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const next = useSelector(store.getNext);
  const isLoading = useSelector(store.isLoading);
  const history = useSelector(store.getHistory);
  const errors = useSelector(store.getErrors);

  const { buttonText = "History", useIcon = false, useIconOnly = false } = props;

  const loadingMessage =
    "This request may take some time. It is processing in the background, and if you leave this window, it will continue processing.";

  const nextHistory = () => {
    next && store.nextHistory(next);
  };

  const toggleOpen = () => {
    if (!isOpen) {
      store.fetchHistory(props.resourceType, props.resourceId);
    } else {
      store.clear();
    }

    setIsOpen(!isOpen);
  };

  return (
    <>
      <InfiniteScrollModal
        closeModal={toggleOpen}
        isOpen={isOpen}
        next={nextHistory}
        title="Product Change History"
      >
        <ErrorBox
          fullHeight={false}
          message={errors?.errorMessage!}
          showIf={useSelector(store.hasErrors)}
        />
        <ListingTable
          columns={defaultColumnConfiguration}
          dataList={history}
          noResultsMessage="No history to display"
          showIf={history.length > 0 || !isLoading}
        />
        <SpinnerLoader showIf={isLoading} height="auto" size={25} loadingMessage={loadingMessage} />
      </InfiniteScrollModal>

      <HistoryButton
        buttonSize={props.buttonSize}
        className={props.className}
        customComponent={props.customComponent}
        onClick={toggleOpen}
        text={buttonText}
        useIcon={useIcon}
        useIconOnly={useIconOnly}
      />
    </>
  );
});
